import axios from "axios";

import ReferenceData from "../constants/ReferenceData";

export const getActivity = () => {
    const url = __baseApiUrl__ + ReferenceData.ACTIVITY_URL;

    return axios({
        method: "get",
        url: url,
        timeout: 5000,
        responseType: "text"
    });
};

export const pingKeepAlive = () => {
    const url = __baseApiUrl__ + ReferenceData.KEEP_ALIVE_URL;

    return axios.get(url);
};
